import classNames from "classnames";
import { useState } from "react";

import { Column } from "src/core/models/global";
import { TableHead } from "src/types/global";

import headCSS from "./Header.module.css";

const MobileHeader = ({
  setRef,
  defaultSort,
  headers,
  onSorting,
}: {
  setRef: (key: number, refElem: any) => void;
  defaultSort: Column;
  headers: Array<TableHead>;
  onSorting: (column: Column) => void;
}) => {
  const [sortColumn, setSortColumn] = useState(defaultSort.name);
  const [sortDescending, setSortDescending] = useState(defaultSort.sortDescending);
  const onSortChange = (field: string) => {
    const order = field === sortColumn && sortDescending ? false : true;
    setSortColumn(field);
    setSortDescending(order);
    onSorting({ name: field, sortDescending: order });
  };

  return (
    <div className={classNames("u-block", "u-pos-fixed", "u-z-index10", "u-w100", "u-h100 ", "u-bg-black", "u-bg-black-light", headCSS.mobileHeadCont)}>
      <div ref={(refElem) => setRef(0, refElem)} className={classNames("u-h8", headCSS.mobileHead)}>
        <div className={headCSS.rectangleH}></div>
        <div className="u-flex u-flex-content-center u-mt10px u-pb10px u-mb20px u-borderSecLight u-w100">
          <h6 className="u-t-f16p u-t-lh15 u-t-secondary u-t-w400 u-t-uppercase u-m0">Poredaj Po:</h6>
        </div>
        <div className="u-flex u-col-12 u-flex-items-center u-flex-column">
          {headers.map((head: TableHead) => {
            return (
              <div
                key={head.field}
                className={classNames("u-cursor-pointer", head.mclass, sortColumn === head.field ? "u-t-primary" : "")}
                onClick={() => (head.sortable ? onSortChange(head.field) : null)}
              >
                {sortColumn && sortColumn === head.field && <span className="u-t-primary u-mr10px">&#10003;</span>}
                {head.name}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
